import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { login } from '../../store/auth/auth.actions';
import { User } from '../../models/user';
import { FormControl } from '@angular/forms';
import { AlertaService } from '../../services/alerta.service';
import { distinctUntilChanged, map, shareReplay } from 'rxjs';
import { UserLogin } from '../../models/user-login';

@Component({
  selector: 'app-loggin',
  standalone: false,
  templateUrl: './loggin.component.html',
  styleUrl: './loggin.component.css'
})
export class LogginComponent {
  user: UserLogin = new UserLogin();;
  emailFormControl: FormControl = new FormControl();
  passFormControl: FormControl = new FormControl();
  loading: boolean = false;
  
  constructor(private alerta: AlertaService, //){
    private authRdcStore: Store<{authRdc: any}>) {
    this.user = new UserLogin();

    this.authRdcStore.pipe(
      select('authRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ loading }) => {
    this.loading = loading;
    });

  }

  onSubmit() {
    if (!this.user.email || !this.user.password) {
      this.alerta.error("El usuario y contraseña son requeridos.");
    } else {
      //this.loading = true;
      this.authRdcStore.dispatch(login({ username: this.user.email, password: this.user.password }));
    }
  }
}